(() => {
 const copy={nl:'Cookies · Meer informatie',de:'Cookies · Mehr erfahren',en:'Cookies · More information'};
 const lang=(document.documentElement.lang||'nl').slice(0,2);
 let queued=false;
 function compact(){
  queued=false;
  if(!matchMedia('(max-width:800px)').matches)return;
  document.querySelectorAll('#cb-cookie_consent .cb-cookie_consent-container-text_container').forEach(text=>{
   if(text.querySelector('.fasola-cookie-details'))return;
   const details=document.createElement('details');
   details.className='fasola-cookie-details';
   const summary=document.createElement('summary');
   summary.textContent=copy[lang]||copy.en;
   const original=document.createElement('div');
   while(text.firstChild)original.appendChild(text.firstChild);
   details.append(summary,original);
   text.appendChild(details);
  });
  const bar=document.querySelector('[data-fasola-mobile-buybar]');
  if(bar){const height=Math.ceil(bar.getBoundingClientRect().height);if(height>0)document.documentElement.style.setProperty('--fasola-mobile-buybar-height',height+'px');}
 }
 function schedule(){if(!queued){queued=true;requestAnimationFrame(compact);}}
 new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});
 window.addEventListener('resize',schedule,{passive:true});
 document.addEventListener('shopify:section:load',schedule);
 schedule();
})();